import {
  MutationDefinition,
  QueryDefinition
} from '@reduxjs/toolkit/dist/query';
import {
  LazyQueryTrigger,
  MutationTrigger,
  UseQueryHookResult
} from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  useActiveTemplateMutation,
  useInActiveTemplateMutation,
  useLazyGetTemplateQuery,
  useLazyGetTemplatesQuery
} from 'app/features/templates/api';
import React from 'react';

export type ITemplate = {
  companyId: number;
  id: number;
  isActive: boolean;
  isDefault: boolean;
  name: string;
  scheme: string;
  templateNo: string;
  createdAt: string;
  updatedAt: string;
};
interface IContext {
  list: UseQueryHookResult<
    QueryDefinition<
      any,
      any,
      any,
      {
        data: any[];
        pagination: any;
      }
    >
  >;
  detail: UseQueryHookResult<QueryDefinition<any, any, any, string>>;
  activeState: any | null;
  inactiveState: any | null;
  fetchList?<T extends QueryDefinition<any, any, any, any>>(
    params: T
  ): LazyQueryTrigger<any>;
  fetchDetail?(params: string): LazyQueryTrigger<any>;
  activeTemplate?<T extends MutationDefinition<any, any, any, any>>(
    payload: T
  ): MutationTrigger<any>;
  inactiveTemplate?<T extends MutationDefinition<any, any, any, any>>(
    payload: T
  ): MutationTrigger<any>;
}
export const TemplateContext = React.createContext<IContext>({
  list: {} as any,
  detail: {} as any,
  activeState: null,
  inactiveState: null
});

const TemplateProvider = ({ children }: any) => {
  const [fetchList, listState] = useLazyGetTemplatesQuery();
  const [fetchDetail, detailState] = useLazyGetTemplateQuery();
  const [activeTemplate, activeState] = useActiveTemplateMutation();
  const [inactiveTemplate, inactiveState] = useInActiveTemplateMutation();

  const context = React.useMemo(() => {
    return {
      list: {
        ...listState
      },
      detail: {
        ...detailState
      },
      activeState: {
        ...activeState
      },
      inactiveState: {
        ...inactiveState
      },
      fetchList,
      fetchDetail,
      activeTemplate,
      inactiveTemplate
    };
  }, [
    listState,
    detailState,
    activeState,
    inactiveState,
    fetchList,
    fetchDetail,
    activeTemplate,
    inactiveTemplate
  ]);

  return (
    <TemplateContext.Provider value={context as any}>
      {children}
    </TemplateContext.Provider>
  );
};

export default TemplateProvider;
